import { useEffect, useMemo, useState } from "react";
import { getStudentStats } from "../../../api/studentsApi";
import GlobalMetricCards from "../../../../../global/GlobalMetricCards";
import GlobalFeedback from "../../../../../global/GlobalFeedback";

const METRIC_KEYS = [
  { key: "registered_today", label: "Registered Today", tone: "mint" },
  { key: "total_registered", label: "Total Registered", tone: "coral" },
];

export default function StudentRegistrationMetricsSection({ refreshKey = 0 }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getStudentStats();
        if (cancelled) return;
        if (result.success) {
          setStats({
            registered_today: result.registered_today,
            total_registered: result.total_registered,
          });
        } else {
          setStats({ registered_today: 0, total_registered: 0 });
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setStats(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  const items = useMemo(
    () =>
      METRIC_KEYS.map(({ key, label, tone }) => ({
        key,
        value: stats?.[key] ?? 0,
        label,
        tone,
      })),
    [stats],
  );

  return (
    <div id="sr-stats" className="student-reg-panel" style={{ scrollMarginTop: "1rem" }}>
      <GlobalFeedback type="error" text={error} />
      {!error ? (
        <GlobalMetricCards
          items={items}
          loading={loading}
          ariaLabel="Student registration statistics"
        />
      ) : null}
    </div>
  );
}
